import { createBrowserRouter }                   from 'react-router-dom';
import { RouterProvider as ReactRouterProvider } from 'react-router-dom';
import AuthLayout                                from '@widesk-ui/layouts/AuthLayout';
import { useAuth }                               from '@widesk-ui/hooks/useAuth';
import LoginPage                                 from '@widesk-ui/pages/LoginPage';
import Layout                                    from '@widesk-ui/layouts/Layout';
import LayoutSider                               from '@/components/LayoutSider';
import LayoutHeader                              from '@/components/LayoutHeader';
import BreadcrumbBar                             from '@widesk-ui/components/BreadcrumbBar';
import ErrorPage                                 from '@widesk-ui/pages/ErrorPage';
import View                                      from '@widesk-ui/components/View';
import Spin                                      from '@widesk-ui/components/Spin';
import Button                                    from '@widesk-ui/components/Button';
import Title                                     from '@widesk-ui/components/Title';
import useTheme                                  from '@widesk-ui/hooks/useTheme';
import Link                                      from '@widesk-ui/components/Link';

// On charge tous les fichiers "Route" du projet
const publicModules = import.meta.glob([
	'./routes/public/*Route.ts',
	'./routes/public/*Route.tsx',
], { eager: true });

const privateModules = import.meta.glob([
	'./routes/private/*Route.ts',
	'./routes/private/*Route.tsx',
	'./routes/private/services/*/*Route.ts',
	'./routes/private/services/*/*Route.tsx',
], { eager: true });

const publicRouter = createBrowserRouter([
	{
		element: <Layout />,
		children: [
			...Object.values(publicModules).flatMap((module: any) => module.default),
			{
				path: '*',
				element: (
					<LoginPage
						footer={<View align="center"><Link to="/reset_password">Mot de passe oublié</Link></View>}
						header={
							<View row={false} center>
								<img src="/logo.svg" alt="Tokamap" />
								<Title marginT="xs" size={18} color="grey">Interface de pilotage</Title>
							</View>
						}
					/>
				),
			},
		],
	},
]);

const privateRouter = createBrowserRouter([
	{
		element: (
			<AuthLayout
				renderHeader={() => <LayoutHeader />}
				renderSider={([collapsed]) => <LayoutSider collapsed={collapsed} />}
				renderTopPage={() => <BreadcrumbBar />}
			/>
		),
		children: [
			...Object.values(privateModules).flatMap((module: any) => module.default),
		],
		errorElement: <ErrorPage />,
	},
]);

export default function RouterProvider() {
	const { token, isLogging } = useAuth();

	return (
		<>
			{token ? (
				isLogging ? <LoadingPage /> : <ReactRouterProvider router={privateRouter} fallbackElement={<LoadingPage />} />
			) : (
				<ReactRouterProvider router={publicRouter} />
			)}
		</>
	);
}

const LoadingPage = () => {
	const { logout } = useAuth();
	const theme = useTheme();

	return (
		<View height="100vh" center gap={20} bg={theme.colorBgContainer} color={theme.colorTextBase}>
			<Spin size="large" tip="Chargement de l'application" />

			<Button type="link" onClick={() => logout()}>Déconnexion</Button>
		</View>
	);
};
